import { useState } from 'react';
import { ArrowLeft, ArrowRight, Upload } from 'lucide-react';
import './styles/PlatformConfiguration.css';

interface Props {
  nextStep: () => void;
  previousStep: () => void;
}

const CompanyProfileSetup = ({ nextStep, previousStep }: Props) => {
  const [companyName, setCompanyName] = useState('Board');
  const [industry, setIndustry] = useState('Board');
  const [country, setCountry] = useState('Board');
  const [website, setWebsite] = useState('Board');
  const [registrationNumber, setRegistrationNumber] = useState('Board');
  const [headOffice, setHeadOffice] = useState('Board');
  const [contactEmail, setContactEmail] = useState('Board');
  const [contactNumber, setContactNumber] = useState('Board');
  const [vision, setVision] = useState('');
  const [mission, setMission] = useState('');

  return (
    <div className="cp-card">
      {/* Header */}
      <div className="cp-header">
        <h2 className="cp-title">Company Profile Setup</h2>
        <p className="cp-subtitle">Company profile for governance reporting</p>
      </div>

      {/* Logo section */}
      <div className="cp-logo-section">
        <div className="cp-logo-preview">
          <div className="cp-logo-box">
            <span className="cp-logo-text">M</span>
            <span className="cp-logo-name">Miyar</span>
          </div>
        </div>
        <div className="cp-logo-info">
          <span className="cp-logo-label">Company Logo</span>
          <span className="cp-logo-hint">Using logo from Branding step</span>
          <button type="button" className="cp-logo-upload">
            <Upload size={14} />
            Upload Different Logo
          </button>
        </div>
      </div>

      {/* Form grid – 2 columns */}
      <div className="cp-form-grid">
        <div className="cp-field">
          <label className="cp-label">
            Company Name <span className="cp-required">*</span>
          </label>
          <select className="cp-select" value={companyName} onChange={(e) => setCompanyName(e.target.value)}>
            <option value="Board">Board</option>
            <option value="Miyar Holding">Miyar Holding</option>
            <option value="Nova">Nova</option>
            <option value="BAA">BAA</option>
            <option value="BCCA">BCCA</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Industry</label>
          <select className="cp-select" value={industry} onChange={(e) => setIndustry(e.target.value)}>
            <option value="Board">Board</option>
            <option value="Finance">Finance</option>
            <option value="Technology">Technology</option>
            <option value="Healthcare">Healthcare</option>
            <option value="Energy">Energy</option>
            <option value="Manufacturing">Manufacturing</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Country</label>
          <select className="cp-select" value={country} onChange={(e) => setCountry(e.target.value)}>
            <option value="Board">Board</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="UAE">UAE</option>
            <option value="Qatar">Qatar</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Oman">Oman</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Website</label>
          <select className="cp-select" value={website} onChange={(e) => setWebsite(e.target.value)}>
            <option value="Board">Board</option>
            <option value="https://miyar.com">https://miyar.com</option>
            <option value="https://example.com">https://example.com</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Registration Number</label>
          <select className="cp-select" value={registrationNumber} onChange={(e) => setRegistrationNumber(e.target.value)}>
            <option value="Board">Board</option>
            <option value="CR-1234567890">CR-1234567890</option>
            <option value="CR-0987654321">CR-0987654321</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Head Office Location</label>
          <select className="cp-select" value={headOffice} onChange={(e) => setHeadOffice(e.target.value)}>
            <option value="Board">Board</option>
            <option value="Riyadh">Riyadh</option>
            <option value="Jeddah">Jeddah</option>
            <option value="Dammam">Dammam</option>
            <option value="Dubai">Dubai</option>
            <option value="Abu Dhabi">Abu Dhabi</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Contact Email</label>
          <select className="cp-select" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}>
            <option value="Board">Board</option>
            <option value="info@miyar.com">info@miyar.com</option>
            <option value="contact@company.com">contact@company.com</option>
          </select>
        </div>

        <div className="cp-field">
          <label className="cp-label">Contact Number</label>
          <select className="cp-select" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)}>
            <option value="Board">Board</option>
            <option value="+966 11 123 4567">+966 11 123 4567</option>
            <option value="+971 4 123 4567">+971 4 123 4567</option>
          </select>
        </div>
      </div>

      {/* Vision */}
      <div className="cp-field cp-field-full">
        <label className="cp-label">Vision</label>
        <textarea
          className="cp-textarea"
          value={vision}
          onChange={(e) => setVision(e.target.value)}
          placeholder="Organization's vision statement..."
          rows={3}
        />
      </div>

      {/* Mission */}
      <div className="cp-field cp-field-full">
        <label className="cp-label">Mission</label>
        <textarea
          className="cp-textarea"
          value={mission}
          onChange={(e) => setMission(e.target.value)}
          placeholder="Organization's mission statement..."
          rows={3}
        />
      </div>

      {/* Footer */}
      <div className="cp-footer">
        <button type="button" onClick={previousStep} className="cp-back-btn">
          <ArrowLeft size={16} />
          Back
        </button>
        <button type="button" onClick={nextStep} className="cp-next-btn">
          Next
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default CompanyProfileSetup;
